




























import CLoader from './CLoader.vue';
export default {
    name: 'editor-link-placeholder',
    components: {
        CLoader
    },
    props: {
        setId: {
            type: String
        },
        size: {
            type: Number,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
};
